module.exports = __webpack_public_path__ + "static/media/FWD_iPhone5.4098df25.png";